import ProductGeneralSettings from "@/models/Products/ProductSettings/ProductGeneralSettings";

export default class UpdateProductGeneralSettingsRequest extends ProductGeneralSettings {
    updatedAt: Date;

    public constructor(settings: ProductGeneralSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        this.description = settings.description;
        this.legacyId = settings.legacyId;
        this.name = settings.name;
        this.code = settings.code;
        this.targetCustomerType = settings.targetCustomerType;
    }
}